//#region src/schema/helpers/format-example.ts
function e(e) {
	let t = e.trim();
	return t === "" ? e : t;
}
function t(t) {
	return Array.isArray(t) ? `[${t.map((t) => typeof t == "string" ? `"${e(t)}"` : typeof t == "object" ? JSON.stringify(t) : t === void 0 ? "undefined" : t === null ? "null" : t).join(", ")}]` : t === null ? "null" : typeof t == "object" ? JSON.stringify(t) : t === void 0 ? "undefined" : e(typeof t == "string" ? t : t.toString());
}
//#endregion
export { t as formatExample };

//# sourceMappingURL=format-example.js.map